import { render, staticRenderFns } from "./columnConfigurations.vue?vue&type=template&id=501bd26a&"
import script from "./columnConfigurations.vue?vue&type=script&lang=js&"
export * from "./columnConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports